import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import moment from 'moment';
import ms from 'ms';
import useCountdown from '../../../hooks/useCountdown';
import Text from '../text';
import Icon from '../icon';
import { formatPeriodTime } from '../../../utils/countdown';
import AnimatedProgressBar from '../animatedProgressBar';
import classnames from 'classnames/bind';
import { ColorNames } from '../../../constants/colorVars';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const COUNTDOWN_UPDATE_FREQUENCIES = {
    EVERY_SECOND: ms('1s'),
    EVERY_THIRTY_SECONDS: ms('1m') / 2,
    EVERY_FIVE_MINUTES: ms('1m') * 5,
};
const PeriodIndicator = ({ className, elmId = 'progress_indicator', color: colorName = ColorNames.Info, iconName, style, title, startDate, endDate, titleOnly = false, fluid, subTitle = 'This event will end in: ', }) => {
    const now = moment();
    const start = startDate ? moment(startDate) : null;
    const end = endDate ? moment(endDate) : null;
    const duration = end ? moment.duration(end.diff(now)) : null;
    const datesAreInvalid = !duration ||
        isNaN(duration.asSeconds()) ||
        moment(startDate).isAfter(endDate);
    const percent = datesAreInvalid
        ? 0
        : moment().isAfter(endDate)
            ? 100
            : Math.min(100, (moment().diff(startDate, 'seconds') /
                moment(endDate).diff(startDate, 'seconds')) *
                100);
    const { secondsRemaining } = useCountdown({
        endTime: moment(endDate),
        updateFrequency: duration && duration.asMinutes() < 5
            ? COUNTDOWN_UPDATE_FREQUENCIES.EVERY_SECOND
            : duration && duration.asMinutes() < 60
                ? COUNTDOWN_UPDATE_FREQUENCIES.EVERY_THIRTY_SECONDS
                : COUNTDOWN_UPDATE_FREQUENCIES.EVERY_FIVE_MINUTES,
    });
    const subtitle = useMemo(() => {
        if (!startDate || !endDate || datesAreInvalid) {
            return '';
        }
        if (start && now.isBefore(start)) {
            return (_jsxs("span", { children: ["This event will start on ", _jsx("strong", { children: start.format('MM/DD') })] }));
        }
        else if (end && now.isAfter(end)) {
            return 'This event has ended';
        }
        else if (end) {
            return (_jsxs("span", { children: [subTitle, _jsx("strong", { children: formatPeriodTime(secondsRemaining) })] }));
        }
        return '';
    }, [startDate, endDate, datesAreInvalid, start, now, end, secondsRemaining]);
    return (_jsxs("div", { className: cx('period-indicator', { fluid }, className), style: style, "data-elm-id": elmId, children: [_jsxs("div", { className: cx('title'), children: [iconName && (_jsx(Icon, { name: iconName, color: colorName, size: 'large', iconStyle: 'solid', className: cx('icon') })), title && (_jsx(Text.Header, { level: 2, color: colorName, className: cx('title-text'), children: title }))] }), !titleOnly && (_jsxs("div", { className: cx('lower-part'), children: [_jsx(Text, { size: 'tiny', color: ColorNames.Gray, className: cx('subtitle'), children: subtitle }), _jsx(AnimatedProgressBar, { color: colorName, percent: percent, rounded: true })] }))] }));
};
export default PeriodIndicator;
//# sourceMappingURL=index.js.map